"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var HostAppView_1 = require("@twii/core-ui-fabric/lib/component/HostAppView");
var Listing_1 = require("./Listing");
var ListingDeleteStore_1 = require("../model/ListingDeleteStore");
var ListingMenuHelper_1 = require("./ListingMenuHelper");
var ListingModelSupplier_1 = require("../model/ListingModelSupplier");
var ListingNavHelper_1 = require("./ListingNavHelper");
var UserAdminContext_1 = require("../../user/UserAdminContext");
var ListingHelper_1 = require("../ListingHelper");
var ListingApprovalStatus_1 = require("../ListingApprovalStatus");
var ListingApp = /** @class */ (function (_super) {
    __extends(ListingApp, _super);
    function ListingApp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onEdit = function () {
            ListingNavHelper_1.pushAndLoad(_this.host, { path: "/ozone/listings/" + _this.listingId + "/edit" });
        };
        _this._onDelete = function () {
            ListingDeleteStore_1.ListingDeleteStore.setValue(_this.listing);
        };
        _this._onOpen = function () {
            _this.host.open({ path: "/ozone/listings/" + _this.listingId + "/launch", makeActive: true, title: _this.listing.title });
        };
        _this._onLoad = function () {
            _this.host.load({ path: "/ozone/listings/" + _this.listingId + "/launch", title: _this.listing.title });
        };
        _this._onSubmit = function () {
            _this.listing.submitForApproval();
        };
        _this._onApprove = function () {
            _this.listing.approve();
        };
        _this._onReject = function () {
            _this.listing.reject();
        };
        _this._onRefresh = function () {
            _this._listingSupplier.refresh();
        };
        return _this;
    }
    Object.defineProperty(ListingApp.prototype, "host", {
        get: function () {
            return this.props.match.host;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListingApp.prototype, "userProfile", {
        get: function () {
            return this.props.match.userProfile;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListingApp.prototype, "isAdmin", {
        get: function () {
            return UserAdminContext_1.UserAdminContext.value(this.userProfile);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListingApp.prototype, "isOwner", {
        get: function () {
            return ListingHelper_1.isOwner(this.listing, this.userProfile);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListingApp.prototype, "listingId", {
        get: function () {
            return this.props.match.params.listingId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListingApp.prototype, "listing", {
        get: function () {
            return this._listingSupplier.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListingApp.prototype, "syncing", {
        get: function () {
            return this._listingSupplier.sync.syncing;
        },
        enumerable: true,
        configurable: true
    });
    ListingApp.prototype.componentWillMount = function () {
        var _this = this;
        var s = new ListingModelSupplier_1.ListingModelSupplier(this.listingId);
        s.load();
        this._listingSupplier = s;
        this._titleSetDisposer = mobx_1.autorun(function () {
            return _this.host.setTitle(s.sync.syncing ? "Loading..." : s.value ? s.value.title + " - Listing Details" : undefined);
        });
    };
    ListingApp.prototype.componentWillUnount = function () {
        if (this._titleSetDisposer) {
            this._titleSetDisposer();
            delete this._titleSetDisposer;
        }
    };
    ListingApp.prototype.render = function () {
        var items = [];
        var backItem = ListingMenuHelper_1.createBackItem(this.host);
        if (backItem) {
            items.push(backItem);
        }
        if (!this.syncing && this.listing) {
            if (this.isAdmin || this.isOwner) {
                items.push({
                    key: "edit",
                    name: "Edit",
                    iconProps: {
                        iconName: "Edit"
                    },
                    onClick: this._onEdit
                });
                var approvalStatus = this.listing.approval_status;
                if (approvalStatus === ListingApprovalStatus_1.ListingApprovalStatus.IN_PROGRESS) {
                    items.push({
                        key: "submit",
                        name: "Submit for Approval",
                        iconProps: { iconName: "WorkFlow" },
                        onClick: this._onSubmit
                    });
                }
                if (this.isAdmin && approvalStatus === ListingApprovalStatus_1.ListingApprovalStatus.PENDING) {
                    items.push({
                        key: "approve",
                        name: "Approve",
                        iconProps: { iconName: "Accept" },
                        onClick: this._onApprove
                    });
                    items.push({
                        key: "reject",
                        name: "Reject",
                        iconProps: { iconName: "Cancel" },
                        onClick: this._onReject
                    });
                }
            }
            if (this.isAdmin) {
                items.push({
                    key: "delete",
                    name: "Delete",
                    iconProps: {
                        iconName: "Delete"
                    },
                    onClick: this._onDelete,
                    disabled: this.syncing
                });
            }
        }
        var farItems = [
            {
                key: "refresh",
                title: "Refresh listing",
                iconProps: {
                    iconName: "Refresh"
                },
                onClick: this._onRefresh,
                disabled: this.syncing
            }
        ];
        return (React.createElement(HostAppView_1.HostAppView, { host: this.host, commandBarProps: { items: items, farItems: farItems } },
            React.createElement(Listing_1.ListingDeleteDialog, { listingSupplier: ListingDeleteStore_1.ListingDeleteStore }),
            React.createElement(Listing_1.ListingContainer, { listingSupplier: this._listingSupplier, onEdit: this._onEdit, onDelete: this._onDelete, onOpen: this._onOpen, onLoad: this._onLoad })));
    };
    ListingApp = __decorate([
        mobx_react_1.observer
    ], ListingApp);
    return ListingApp;
}(React.Component));
exports.ListingApp = ListingApp;
exports.default = ListingApp;
